import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import type { InsightsLandingView } from "./insightsLandingView";

export type InsightsViewToggleProps = Readonly<{
  value: InsightsLandingView;
  onChange: (view: InsightsLandingView) => void;
}>;

const buttonSx = {
  width: 32,
  height: 28,
  minWidth: 32,
  p: 0,
  m: 0,
  border: "none",
  borderRadius: "6px !important",
  color: "#434653",
  "&.MuiToggleButtonGroup-grouped": {
    border: "none",
    borderRadius: "6px !important",
    margin: 0,
    "&:not(:first-of-type)": {
      marginLeft: 0,
      borderLeft: "none",
      borderRadius: "6px !important",
    },
    "&:not(:last-of-type)": {
      borderRadius: "6px !important",
    },
  },
  "&.Mui-selected": {
    bgcolor: "#fff",
    color: "#295EF1",
    boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
    "&:hover": { bgcolor: "#fff" },
  },
} as const;

export function InsightsViewToggle({ value, onChange }: InsightsViewToggleProps) {
  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      aria-label="Insights view"
      onChange={(_event, next: InsightsLandingView | null) => {
        if (next) onChange(next);
      }}
      sx={{
        bgcolor: "#F2F2F2",
        border: "none",
        borderRadius: "4px",
        p: "4px",
        gap: "2px",
        "& .MuiToggleButtonGroup-grouped": {
          border: 0,
        },
      }}
    >
      <ToggleButton value="list" aria-label="List view" title="List view" sx={buttonSx}>
        <ViewListOutlinedIcon sx={{ fontSize: 16 }} />
      </ToggleButton>
      <ToggleButton value="card" aria-label="Card view" title="Card view" sx={buttonSx}>
        <GridViewOutlinedIcon sx={{ fontSize: 16 }} />
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
